import type { App } from 'vue'
import Breadcrumb from '@/components/common/Breadcrumb.vue'
import Table from '@/components/common/Table.vue'
import Input from '@/components/common/Input.vue'
import CollapseCriteria from '@/components/base/CollapseCriteria.vue'
import Button from '@/components/common/Button.vue'
import Select from '@/components/common/Select.vue'
import DirectoryTree from '@/components/common/DirectoryTree.vue'
import DatePicker from '@/components/common/RangeDatePicker.vue'
import mixins from '@/mixins'
import InputNumber from '@/components/common/InputNumber.vue'
export default {
  install(app: App) {
    app.component('CBreadCrumb', Breadcrumb)
    app.component('CTable', Table)
    app.component('CInput', Input)
    app.component('CNumberInput', InputNumber)
    app.component('CollapseCriteria', CollapseCriteria)
    app.component('CButton', Button)
    app.component('CSelect', Select)
    app.component('CDirectoryTree', DirectoryTree)
    app.component('CRangePicker', DatePicker)

    app.mixin(mixins)
  }
}
